import { render, staticRenderFns } from "./EditMaterialContainer.vue?vue&type=template&id=1155e8ca"
import script from "./EditMaterialContainer.vue?vue&type=script&lang=js"
export * from "./EditMaterialContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports